/**
 * External dependencies
 */
export default class Install {
    constructor(cscom) {
        if (!(this instanceof Install)) {
            return new Install(cscom);
        }
        this.cscom = cscom;
    }

    getInstallResponse() {
        return this.cscom.req.get('/sgc/app/get-install');
    }

    verifyInstall(hmac, host, session, shop, timestamp, tenantid) {
        // return this.cscom.req.get('/sgc/app/install', details).then((result) => {
        //     return result;
        // });

        if (session) {
            return this.cscom.req.get('/sgc/app/install', { hmac, host, session, shop, timestamp, tenantid });
        } else {
            return this.cscom.req.get('/sgc/app/install', { hmac, host, shop, timestamp, tenantid });
        }
    }
}
